var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "9.33 16.29 61.34 50.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1668 17.8665L9.83348 61.5665C8.46681 63.7998 10.0668 66.6665 12.6668 66.6665H67.3335C69.9668 66.6665 71.5335 63.7998 70.1668 61.5665L42.8335 17.8665C41.5335 15.7665 38.4668 15.7665 37.1668 17.8665Z",
    fill: "#E02020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 56.6667C41.841 56.6667 43.3334 55.1743 43.3334 53.3333C43.3334 51.4924 41.841 50 40.0001 50C38.1591 50 36.6667 51.4924 36.6667 53.3333C36.6667 55.1743 38.1591 56.6667 40.0001 56.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 30C38.1667 30 36.6667 31.5 36.6667 33.3333V43.3333C36.6667 45.1667 38.1667 46.6667 40.0001 46.6667C41.8334 46.6667 43.3334 45.1667 43.3334 43.3333V33.3333C43.3334 31.5 41.8334 30 40.0001 30Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.17ef29de519217bc5e03f41b039a5526.svg";
export { ForwardRef as ReactComponent };